import { Link } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";

export default function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);

  useEffect(() => {
    const closeOnResize = () => {
      if (window.innerWidth >= 992) setOpen(false);
    };

    window.addEventListener("resize", closeOnResize);
    return () => window.removeEventListener("resize", closeOnResize);
  }, []);

  return (
    <nav
      className="navbar navbar-expand-lg sticky-top"
      style={{
        background: "rgba(2,6,23,0.82)",
        backdropFilter: "blur(18px)",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 10px 35px rgba(0,0,0,0.18)"
      }}
    >
      <div className="container">
        {/* ===== LOGO ===== */}
        <Link
          className="navbar-brand d-flex align-items-center gap-2"
          to="/"
          onClick={closeMenu}
          style={{
            fontWeight: 900,
            color: "#ffffff",
            textDecoration: "none",
            letterSpacing: "0.2px"
          }}
        >
          <div
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background:
                "linear-gradient(135deg, rgba(56,189,248,0.18), rgba(34,197,94,0.18))",
              border: "1px solid rgba(255,255,255,0.08)",
              fontSize: "1.2rem"
            }}
          >
            🎯
          </div>

          <div className="d-flex flex-column">
            <span style={{ fontSize: "1rem", lineHeight: "1.1" }}>
              UPSC Titan Score
            </span>
            <small
              style={{
                color: "#94a3b8",
                fontSize: "0.68rem",
                fontWeight: 700,
                letterSpacing: "0.7px"
              }}
            >
              PREMIUM LEARNING PLATFORM
            </small>
          </div>
        </Link>

        {/* ===== MOBILE TOGGLER ===== */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setOpen(!open)}
          style={{
            border: "1px solid rgba(255,255,255,0.10)",
            background: "rgba(255,255,255,0.04)",
            borderRadius: "14px",
            padding: "8px 12px"
          }}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* ===== NAV ITEMS ===== */}
        <div className={`collapse navbar-collapse ${open ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-1 mt-3 mt-lg-0">
            <li className="nav-item">
              <Link onClick={closeMenu} className="nav-link custom-nav-link" to="/">
                Home
              </Link>
            </li>

            <li className="nav-item">
              <Link onClick={closeMenu} className="nav-link custom-nav-link" to="/about">
                About
              </Link>
            </li>

            <li className="nav-item">
              <Link onClick={closeMenu} className="nav-link custom-nav-link" to="/privacy">
                Privacy
              </Link>
            </li>

            <li className="nav-item">
              <Link onClick={closeMenu} className="nav-link custom-nav-link" to="/terms">
                Terms
              </Link>
            </li>

            <li className="nav-item">
              <Link onClick={closeMenu} className="nav-link custom-nav-link" to="/disclaimer">
                Disclaimer
              </Link>
            </li>

            {/* ===== AUTH CONTROL ===== */}
            {user ? (
              <>
                <li className="nav-item">
                  <Link
                    onClick={closeMenu}
                    className="btn ms-lg-3 mt-2 mt-lg-0"
                    to="/Pre"
                    style={dashboardBtnStyle}
                  >
                    Open Dashboard
                  </Link>
                </li>

                <li className="nav-item ms-lg-2">
                  <button
                    className="btn mt-2 mt-lg-0"
                    onClick={() => {
                      logout();
                      closeMenu();
                    }}
                    style={logoutBtnStyle}
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <Link
                    onClick={closeMenu}
                    className="btn mt-2 mt-lg-0 ms-lg-3"
                    to="/login"
                    style={loginBtnStyle}
                  >
                    Login
                  </Link>
                </li>

                <li className="nav-item ms-lg-2">
                  <Link
                    onClick={closeMenu}
                    className="btn mt-2 mt-lg-0"
                    to="/register"
                    style={registerBtnStyle}
                  >
                    Register
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>

      <style>{`
        .custom-nav-link {
          color: #cbd5e1 !important;
          font-weight: 700;
          font-size: 0.95rem;
          padding: 10px 14px !important;
          border-radius: 12px;
          transition: all 0.25s ease;
        }

        .custom-nav-link:hover {
          color: #ffffff !important;
          background: rgba(255,255,255,0.06);
        }

        @media (max-width: 991px) {
          .navbar-collapse {
            margin-top: 14px;
            padding: 16px;
            border-radius: 20px;
            background: rgba(15,23,42,0.95);
            border: 1px solid rgba(255,255,255,0.08);
          }
        }
      `}</style>
    </nav>
  );
}

/* ================= BUTTON STYLES ================= */
const loginBtnStyle = {
  borderRadius: "14px",
  padding: "10px 18px",
  border: "1px solid rgba(255,255,255,0.14)",
  color: "#f8fafc",
  background: "rgba(255,255,255,0.05)",
  fontWeight: 800,
  fontSize: "0.92rem"
};

const registerBtnStyle = {
  borderRadius: "14px",
  padding: "10px 18px",
  border: "none",
  color: "#0f172a",
  background: "linear-gradient(135deg, #facc15, #f59e0b)",
  fontWeight: 900,
  fontSize: "0.92rem",
  boxShadow: "0 10px 24px rgba(250,204,21,0.18)"
};

const dashboardBtnStyle = {
  borderRadius: "14px",
  padding: "10px 18px",
  border: "none",
  color: "#ffffff",
  background: "linear-gradient(135deg, #22c55e, #16a34a)",
  fontWeight: 900,
  fontSize: "0.92rem",
  boxShadow: "0 10px 24px rgba(34,197,94,0.18)"
};

const logoutBtnStyle = {
  borderRadius: "14px",
  padding: "10px 18px",
  border: "1px solid rgba(255,255,255,0.12)",
  color: "#f8fafc",
  background: "rgba(255,255,255,0.04)",
  fontWeight: 800,
  fontSize: "0.92rem"
};